import type { CardComponentProps } from 'nextstepjs'
import { VpButton, VpIcon, VpIconButton } from '@vtmn-play/react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

export function ProductGalleryOnboardingTourCard({
  arrow,
  currentStep,
  nextStep,
  prevStep,
  skipTour,
  step,
  totalSteps,
}: Readonly<CardComponentProps>) {
  const { t } = useTranslation()
  const isFirstStep = currentStep === 0
  const isLastStep = currentStep === totalSteps - 1

  return (
    <div
      className="product-gallery-onboarding__tooltip"
      data-testid="product-gallery-onboarding-tour"
      role="dialog"
      aria-modal="true"
      aria-labelledby="product-gallery-onboarding-tour-title"
    >
      {arrow}
      <div className="product-gallery-onboarding__tooltip-header">
        <h2 id="product-gallery-onboarding-tour-title" className="product-gallery-onboarding__tooltip-header-title">{step.title}</h2>
        <VpIconButton
          aria-label={t('close')}
          className="product-gallery-onboarding__close"
          size="small"
          variant="tertiary"
          onClick={() => skipTour?.()}
        >
          <VpIcon name="close" />
        </VpIconButton>
      </div>
      <p className="product-gallery-onboarding__tooltip-description">
        {step.content}
      </p>
      <div className="product-gallery-onboarding__tooltip-footer">
        <div className="product-gallery-onboarding__dots" aria-hidden="true">
          {Array.from({ length: totalSteps }, (_, index) => (
            <span
              key={index}
              className={clsx('product-gallery-onboarding__dot', {
                'product-gallery-onboarding__dot--active': index === currentStep,
              })}
            />
          ))}
        </div>
        <div className="product-gallery-onboarding__tooltip-actions">
          <VpButton
            disabled={isFirstStep}
            variant="secondary"
            size="small"
            onClick={prevStep}
          >
            {t('products-page.onboarding.actions.previous')}
          </VpButton>
          <VpButton variant="primary" size="small" onClick={nextStep}>
            {t(`products-page.onboarding.actions.${isLastStep ? 'finish' : 'next'}`)}
          </VpButton>
        </div>
      </div>
    </div>
  )
}
